import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom'; // Import useNavigate hook
import { Form, Col, Button } from 'react-bootstrap'; // Import Form and Col from react-bootstrap
import './add-leave.css'; // Import your CSS file
import { FaRegCalendarPlus } from "react-icons/fa6";
import { RiAddCircleFill } from "react-icons/ri";

const AddLeave = () => {
    // State to hold form values
    const [leaveType, setLeaveType] = useState('');
    const [reason, setReason] = useState('');

    // State to hold error messages
    const [errors, setErrors] = useState({});

    const navigate = useNavigate(); // Initialize useNavigate hook

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault(); // Prevent the default form submission behavior

        // Simple validation example
        let formErrors = {};
        if (!leaveType) formErrors.leaveType = 'Leave type is required';
        if (!reason) formErrors.reason = 'Reason is required';

        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors);
            return;
        }

        // Process form data
        console.log({
            leaveType,
            reason
        });

        // Clear the form after submission if needed
        setLeaveType('');
        setReason('');
        setErrors({});

        // Navigate to the Pending Leave page
        navigate('./pending-leave');
    };

    return (
        <div className="add-leave-container">
            <section>
                <div className="main-box-upper">
                    <h1 className="title"><FaRegCalendarPlus />
                    Apply Leave</h1>
                    <hr />
                </div>
            </section>
            <form className="form-container" onSubmit={handleSubmit}>
                <div className="form-box">
                    <div className="form-row">
                        <div className="form-column">
                            <div className="form-group">
                                <label htmlFor="leave_type">
                                    Leave type <span className="required">*</span> :
                                </label>
                                <select
                                    id="leave_type"
                                    className="form-control"
                                    required
                                    name="leave_type"
                                    value={leaveType}
                                    onChange={(e) => setLeaveType(e.target.value)}
                                >
                                    <option value="">--Select--</option>
                                    <option value="simple">Simple Leave</option>
                                    <option value="half">Half Leave</option>
                                    <option value="full">Full Leave</option>
                                    <option value="details">Details Leave</option>
                                    <option value="maternity">Maternity Leave</option>
                                </select>
                                {errors.leaveType && <p className="error-text">{errors.leaveType}</p>}
                            </div>
                            <Form.Group as={Col} xs={12} md={6} controlId="formGridDays">
                                <Form.Label>
                                    Days <span className='required'>*</span>:
                                </Form.Label>
                                <Form.Control 
                                    type="number" 
                                    name="days" 
                                    required 
                                    placeholder="Day" 
                                    className="days-counter" 
                                />
                            </Form.Group>
                            <div className="form-group">
                                <label htmlFor="leave_reason">
                                    Reason <span className="required">*</span> :
                                </label>
                                <textarea
                                    id="leave_reason"
                                    className="form-control form-control-reason"
                                    required
                                    name="leave_reason"
                                    value={reason}
                                    onChange={(e) => setReason(e.target.value)}
                                ></textarea>
                                {errors.reason && <p className="error-text">{errors.reason}</p>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="form-actions">
                    <Link to = '/pending-leave'>
                    <Button className="btn btn-primary" type="submit">
                        <i className="fa fa-plus"></i><RiAddCircleFill />
                        Add Leave
                    </Button>
                    </Link>
                </div>
            </form>
        </div>
    );
};

export default AddLeave;
